import { Injectable, Injector } from '@angular/core';
import { IMedication, IMedicationResult, ISaveMedication } from '../../models/medication.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConsultationRecommendationService } from '../consultation-recommendation/consultation-recommendation.service';
import { RecommendationType } from '../../models/consultation-recommendation.model';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';

const STORAGE_KEY = 'recommendedMedications';

@Injectable({
  providedIn: 'root'
})
export class MedicationService {

  private readonly medicationSubject = new BehaviorSubject<IMedication[]>([]);
  medications$ = this.medicationSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly injector: Injector
  ) {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      this.medicationSubject.next(JSON.parse(stored));
    }
  }

  notifyOpenDrawer() {
    //to avoid the circular dependency, using injector
    const consultationRecommendationService = this.injector.get(ConsultationRecommendationService);
    consultationRecommendationService.openDrawer(RecommendationType.Medication);
  }


  setMedications(medications: IMedication[], isDataFromService = false) {
    this.medicationSubject.next(medications);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(medications));

    if (isDataFromService && medications.length) {
      this.notifyOpenDrawer();
    }
  }

  addMedication(medication: IMedication) {
    const updated = [...this.medicationSubject.value, medication];
    this.setMedications(updated);
  }

  toggleItem(index: number) {
    const items = [...this.medicationSubject.value];
    items[index].checked = !items[index].checked;
    this.setMedications(items);
  }

  updateMedication(index: number, editMedication: IMedication) {
    if (index !== null) {
      const values = this.getMedications();

      let oldVal = values[index];
      oldVal = { ...oldVal, ...editMedication }
      values[index] = oldVal
      this.setMedications(values);
    }
  }

  generateMedications(
    transcript: string,
  ): Observable<{ response: { prescriptions: IMedication[] } }> {
    return this.http.post<{ response: { prescriptions: IMedication[] } }>(
      environment.cva_url + API_ROUTES.AI_PROXY + API_ROUTES.GENERATE_MEDICATIONS,
      { transcript }
    )
  }

  save(payload: ISaveMedication): Observable<IMedicationResult> {
    const url = `${environment.cva_url}${API_ROUTES.MEDICATION_REQUEST}`;
    return this.http.post<IMedicationResult>(url, payload)
  }

  getMedications() {
    return this.medicationSubject.value;
  }

  clearAll() {
    this.setMedications([]);
  }
}
